import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { DatasetStatus } from '@components'
import { Loader } from '@components/v2/loader'
import { useAssignmentsExecution } from '@datasets/dataset-details/datasetHistoryV2/hooks/useAssignmentsExecution'
import * as css from '@datasets/dataset-details/datasetHistoryV2/styled'
import { DatasetSubmissionOutboundIntegration } from '@datasets/dataset-details/datasetHistoryV2/types'

interface OutboundDestinationsTableRowProps {
  outbound: DatasetSubmissionOutboundIntegration
  onClickOpenDrawer: () => void
  submissionStatus: DatasetStatus | undefined
  datasetSubmissionId: number
}

export const OutboundDestinationsTableRow = ({
  outbound,
  onClickOpenDrawer,
  datasetSubmissionId,
}: OutboundDestinationsTableRowProps) => {
  const { getOutboundStatus, isLoadingAssignmentExecution } =
    useAssignmentsExecution(datasetSubmissionId)

  const { success, total } = getOutboundStatus(outbound?.integrationAssignments)

  return (
    <TableRow
      key={outbound.name}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      hover={true}
      onClick={onClickOpenDrawer}
    >
      <TableCell component="td" scope="row" sx={{ borderColor: '#C4C4C4' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <css.HeightLimitedImg
            src={`https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${outbound.slug}.png`}
            alt={outbound.name}
          />
          <div>{outbound.name}</div>
        </div>
      </TableCell>
      <TableCell align="center" sx={{ borderColor: '#C4C4C4' }}>
        {isLoadingAssignmentExecution ? (
          <div className="flex items-center justify-center">
            <Loader />
          </div>
        ) : (
          `${success} / ${total}`
        )}
      </TableCell>
    </TableRow>
  )
}
